export default "__VITE_ASSET__CmTlytly__"